<template>
  <div class="wid-1200" id="ddjs">
    <ContentTitle title="党的建设" :to="`/#/DdConstruct/${activeName}`"></ContentTitle>
    <el-collapse v-model="activeName" accordion @change="handleChange">
      <el-collapse-item
        :disabled="Number(activeName)===i"
        :name="i.toString()"
        v-for="(item, i) in list"
        :key="item.id"
      > 
      <template slot="title">{{ item.columnName }}</template>
        <div class="toggle-open" v-if="data.length>0">
          <a class="toggle-open-left u-l" :href="data[0].linkUrl" target="_blank">
            <img :src="item.src0" />
            <div class="ddjs-tit-cont u-clearfix">
              <h2>{{ data[0].buildTitle.split('——')[0] }}</h2>
              <h2 v-if="data[0].buildTitle.split('——')[1]">——{{ data[0].buildTitle.split('——')[1] }}</h2>
              <p :title="data[0].buildAbstract">{{ characterEllipsis(data[0].buildAbstract,90) }}</p>
              <span>{{ data[0].buildSource }}</span>
              <span>{{ data[0].buildPubTime }} </span>
            </div>
          </a>
          <div class="toggle-open-right u-r">
            <a class="ddjs-rt-up" :href="data[1].linkUrl" target="_blank">
              <img :src="item.src1" />
              <div class="ddjs-mask">
                <p :title="data[1].buildTitle">{{ characterEllipsis(data[1].buildTitle,30) }}</p>
              </div>
            </a>
            <a class="ddjs-rt-up" :href="data[2].linkUrl" target="_blank">
              <img :src="item.src2" />
              <div class="ddjs-mask">
                <p :title="data[2].buildTitle">{{ characterEllipsis(data[2].buildTitle,30) }}</p>
              </div>
            </a>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import ContentTitle from "../../components/ContentTitle.vue";
import {partyBuildingMixin} from '../../mixins/mixin'
export default {
  name: "PartyBuilding",
  mixins:[partyBuildingMixin],
  components: {
    ContentTitle,
  },
  props:['downloadUrl'],
  data() {
    return {
    };
  },
  methods: {
    handleChange(){
      this.getPartyBuildingData()
    },
    characterEllipsis(str,num) {
      if(!str) return
      if (str.length < num) return str
      return str.substr(0, num) + '......'
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep{
.el-collapse {
  display: flex;
  height: 520px;
  border: none;
}
.el-collapse-item__header {
  width: 83px;
  height: 100%;
  padding: 0 28px;
  font-weight: 700;
  font-size: 24px;
  line-height: 2;
  letter-spacing: 22px;
  color: #f9fdcc;
  cursor: pointer;
  border: none;
  background: url("../../assets/images/collapse/1.png") no-repeat;
  // background: url("../../assets/images/party_building_bg.png") no-repeat;
  &:hover,&.is-active{
    background-image: url("../../assets/images/collapse/1_hover.png");
    // background-image: url("../../assets/images/party_building_cur_bg.png");
  }
}
.el-collapse-item__arrow {
  display: none;
}
.el-collapse-item__wrap {
  display: block !important;
  width: 0;
  color: #fff;
  transition: width 1s;
  border-bottom: none;
}
.el-collapse-item__content {
  height: 520px;
  color: #000;
  font-size: 16px;
  line-height: 1.3;
}
.el-collapse-item {
  flex: 1;
  display: flex;
  height: 520px;
  &.is-active {
    .el-collapse-item__wrap {
      width: 544px;
      margin: 0 10px;
    }
  }
  &.is-disabled .el-collapse-item__header{
    color: #f9fdcc;
  }
  &:nth-child(2) {
    .el-collapse-item__header {
      // background-position: -83px 0;
      background: url("../../assets/images/collapse/2.png");
      &:hover,&.is-active{
      // background-position: -83px 0;
        background-image: url("../../assets/images/collapse/2_hover.png");
      }
    }
  }
  &:nth-child(3) {
    .el-collapse-item__header {
      // background-position: -166px 0;
      background: url("../../assets/images/collapse/3.png");
      &:hover,&.is-active{
      // background-position: -166px 0;
        background-image: url("../../assets/images/collapse/3_hover.png");
      }
    }
  }
  &:nth-child(4) {
    .el-collapse-item__header {
      // background-position: -249px 0;
      background: url("../../assets/images/collapse/4.png");
      &:hover,&.is-active{
      // background-position: -249px 0;
        background-image: url("../../assets/images/collapse/4_hover.png");
      }
    }
  }
  &:nth-child(5) {
    .el-collapse-item__header {
      // background-position: -332px 0;
      background: url("../../assets/images/collapse/5.png");
      &:hover,&.is-active{
      // background-position: -332px 0;
        background-image: url("../../assets/images/collapse/5_hover.png");
      }
    }
  }
  &:nth-child(6) {
    .el-collapse-item__header {
      // background-position: -415px 0;
      background: url("../../assets/images/collapse/6.png");
      &:hover,&.is-active{
        // background-position: -415px 0;
        background-image: url("../../assets/images/collapse/6_hover.png");
      }
    }
  }
  &:last-child {
    .el-collapse-item__header {
      // background-position: -498px 0;
      background: url("../../assets/images/collapse/7.png");
      &:hover,&.is-active{
      // background-position: -498px 0;
        background-image: url("../../assets/images/collapse/7_hover.png");
      }
    }
  }
}

.toggle-open {
  width: 544px;
  height: 520px;
  background-color: #fff;
  background-size: contain;
  .toggle-open-left {
    width: 325px;
    height: 520px;
    background: #fef2f4;
    img{
      width: 325px;
      height: 194px;
    }
    .ddjs-tit-cont {
      padding: 15px 20px;

      h2 {
        font-weight: 700;
        font-size: 20px;
        line-height: 26px;
        color: #000000;
      }
      p {
        text-indent: 2em;
        margin-top: 20px;
      }
      span {
        display: block;
        text-align: right;
      }
    }
  }
  .toggle-open-right {
    width: 209px;
    height: 520px;
    .ddjs-rt-up {
      position: relative;
      display: block;
      img{
        width: 209px;
        height: 255px;
      }
      .ddjs-mask {
        box-sizing: border-box;
        width: 209px;
        height: 76px;
        bottom: 0;
        padding: 10px;
        background: rgba(0, 0, 0, 0.55);
        line-height: 1.3;
        margin-top: 10px;
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0;
        p {
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 1px;
        }
      }
      & + .ddjs-rt-up {
        margin-top: 10px;
      }
    }
  }
}
}
</style>